import moment from 'moment';
import React from 'react';
import { Grid, Header, Message, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';

type AtencionesOrientacionDTO = Resultados<'atencionesOrientacionDeAlumno'>;
type AtencionesPsicopedagogiaDTO = Resultados<'atencionesPsicopedagogiaDeAlumno'>;

export type Props = Readonly<{
    atencionesOrientacion: AtencionesOrientacionDTO;
    atencionesPsicopedagogia: AtencionesPsicopedagogiaDTO;
}>;
class AtencionesOrientacionPsicopedagogiaDeAlumno extends React.PureComponent<Props> {
    public render() {
        const { atencionesOrientacion, atencionesPsicopedagogia } = this.props;

        return (
            <div>
                <Grid columns={2} divided>
                    <Grid.Row>
                        <Grid.Column>
                            <Header as='h3' content='Orientación' />
                            {atencionesOrientacion.length === 0 ? (
                                <div>
                                    <Message info>
                                        <Message.Content>
                                            El alumno no posee atenciones de orientación
                                            registradas.
                                        </Message.Content>
                                    </Message>
                                </div>
                            ) : (
                                <Table collapsing textAlign='center'>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell content='Fecha' />
                                            <Table.HeaderCell content='Hora' />
                                            <Table.HeaderCell content='' />
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {atencionesOrientacion.map(atencion => (
                                            <Table.Row
                                                key={atencion.idAtencion}
                                                negative={atencion.tipoDeAtencion === 'ausente'}
                                            >
                                                <Table.Cell
                                                    content={moment(
                                                        Fecha(atencion.fechaYHora),
                                                    ).format('DD-MM-YYYY')}
                                                />
                                                <Table.Cell content={Hora(atencion.fechaYHora)} />
                                                <Table.Cell
                                                    textAlign='left'
                                                    content={
                                                        atencion.tipoDeAtencion === 'excepcional'
                                                            ? 'Atención excepcional'
                                                            : atencion.tipoDeAtencion === 'ausente'
                                                            ? 'No asistió'
                                                            : ''
                                                    }
                                                />
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}
                        </Grid.Column>

                        <Grid.Column>
                            <Header as='h3' content='Psicopedagogía' />
                            {atencionesPsicopedagogia.length === 0 ? (
                                <div>
                                    <Message info>
                                        <Message.Content>
                                            El alumno no posee atenciones de psicopedagogía
                                            registradas.
                                        </Message.Content>
                                    </Message>
                                </div>
                            ) : (
                                <Table collapsing textAlign='center'>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell content='Fecha' />
                                            <Table.HeaderCell content='Hora' />
                                            <Table.HeaderCell content='' />
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {atencionesPsicopedagogia.map(atencion => (
                                            <Table.Row
                                                key={atencion.idAtencion}
                                                negative={atencion.tipoDeAtencion === 'ausente'}
                                            >
                                                <Table.Cell
                                                    content={moment(
                                                        Fecha(atencion.fechaYHora),
                                                    ).format('DD-MM-YYYY')}
                                                />
                                                <Table.Cell content={Hora(atencion.fechaYHora)} />
                                                <Table.Cell
                                                    textAlign='left'
                                                    content={
                                                        atencion.tipoDeAtencion === 'excepcional'
                                                            ? 'Atención excepcional'
                                                            : atencion.tipoDeAtencion === 'ausente'
                                                            ? 'No asistió'
                                                            : ''
                                                    }
                                                />
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const caracteresAntesDeT = /[^T]*/;

const caracteresDespuesDeT = /[^T]*$/;

function Fecha(fechaYHora: string) {
    return String(fechaYHora.match(caracteresAntesDeT));
}

function Hora(fechaYHora: string) {
    return String(fechaYHora.match(caracteresDespuesDeT));
}

export default AtencionesOrientacionPsicopedagogiaDeAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/AtencionesOrientacionPsicopedagogia/index.tsx